import { useI18n } from 'vue-i18n';

import { formStore } from '@/stores/form';

export function useVirtualAssistant() {
  const { funnelEntry, funnelType, stepKey } = formStore();
  const { t } = useI18n();

  const funnelEntries = ['aansprakelijkheid', 'inboedel', 'woonhuis', 'gezinsongevallen', 'doorlopendeReis', 'rechtsbijstand'];

  const funnelKey = funnelEntries.includes(funnelEntry) ? funnelEntry : funnelType;

  const assistantTitle = () => {
    return t(`virtual-assistant.${funnelKey}.${stepKey}.assistantTitle`);
  };
  const assistantExpertise = () => {
    return t(`virtual-assistant.${funnelKey}.${stepKey}.assistantExpertise`);
  };
  const assistantBody = () => {
    return t(`virtual-assistant.${funnelKey}.${stepKey}.assistantBody`);
  };
  return { assistantTitle, assistantExpertise, assistantBody };
}
